export default __webpack_public_path__ + "static/media/delivery_bro.7b192cc3.svg";